import { HttpClient } from '@angular/common/http';
import { inject, isDevMode } from '@angular/core';

import { Logger, LogLevel } from '@ideals/core/logger';
import { PlatformService } from '@ideals/core/platform';

import { DataTransporterService } from '../data-transporter';

interface JsLogData {
  readonly Application: 'app-frontend';
  readonly Browser: string;
  readonly ClientType: string;
  readonly Exception: string;
  readonly HostId: string;
  readonly Level: LogLevel;
  readonly Message: string;
  readonly Os: string;
  readonly RoomId: string;
  readonly RoomName: string;
  readonly Url: string;
}

export class RemoteLoggerService extends Logger {
  readonly #dataTransporterService = inject(DataTransporterService);
  readonly #httpClient = inject(HttpClient);
  readonly #platformService = inject(PlatformService);

  override available(): boolean {
    return !isDevMode();
  }

  override saveHttpLog(): void {}

  override saveJsLog(error: Error, exception: string, level: LogLevel): void {
    const log = this.#formatJsLog(error, exception, level);

    this.#httpClient.post('/api/v1/log', log).subscribe();
  }

  #formatJsLog(error: Error, exception: string, level: LogLevel): JsLogData {
    const deviceInfo = this.#platformService.deviceInfo();
    const platformType = this.#platformService.platformType();
    const project = this.#dataTransporterService.getProject();

    return {
      Application: 'app-frontend',
      Browser: `${deviceInfo.browser} ${deviceInfo.browser_version}`,
      ClientType: platformType,
      Exception: exception,
      HostId: project?.hostId ?? '',
      Level: level,
      Message: error.message,
      Os: `${deviceInfo.os} ${deviceInfo.os_version}`,
      RoomId: project?.id ?? '',
      RoomName: project?.name ?? '',
      Url: window.location.href,
    };
  }
}
